export default __webpack_public_path__ + "static/media/arcaneplunder.caea6b91.png";